import { TemplateManager } from "@/components/templates/TemplateManagerDialog";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui-kit/Card";

export function ActivityTemplatesCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Activity templates</CardTitle>
        <CardDescription>Pre-fill descriptions and an optional default time when logging.</CardDescription>
      </CardHeader>
      <CardContent><TemplateManager /></CardContent>
    </Card>
  );
}
